import { useContext } from 'react';

import { TaskListSearchContext, TaskListSearchContextProps } from './context';

export const useTaskListSearch = (): TaskListSearchContextProps =>
  useContext(TaskListSearchContext);
